import { render, staticRenderFns } from "./NotificationTimelineNotificationLogItem.vue?vue&type=template&id=f4b8dcda&scoped=true&"
import script from "./NotificationTimelineNotificationLogItem.vue?vue&type=script&lang=ts&"
export * from "./NotificationTimelineNotificationLogItem.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationTimelineNotificationLogItem.vue?vue&type=style&index=0&id=f4b8dcda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b8dcda",
  null
  
)

export default component.exports